export class Coupon {
  id: string;
  amountOff: string; // may be a number
  created: Date;
  currency: string;
  durationInMonths: number;
  livemode: boolean;
  maxRedemptions: number;
  percentOff: number;
  reedemBy: Date;
  timesReedemed: number;
  valid: boolean;

  constructor(json: any) {
    try {
      this.id = json.id;
      // this.amountOff = json.amount_off;
      // this.created = new Date(json.created);
      this.percentOff = json.percent_off;
      this.valid = json.valid;
    } catch (ex) {
      this.id = '';
      this.percentOff = 0;
      this.valid = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/coupon.ts